import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "../components/Navbar";
import { Container } from "react-bootstrap";
import store from "../store";
import { setGoogleClickId } from "../store/bookingSlice";
import { useCookies } from "react-cookie";

export default function Root() {
  const location = useLocation();
  const [gclidCookie] = useCookies(["gclid"]);
  // @TODO: there must be a better way
  const useContainer = !location.pathname.match(/^\/locations\/[^/]+\/units\/?$/);

  useEffect(() => {
    if (gclidCookie) {
      console.log("Setting GCLID: ", gclidCookie.gclid);
      store.dispatch(setGoogleClickId(`${gclidCookie.gclid}`));
    }
  }, [gclidCookie]);

  // useEffect(() => {
  //   const titleParts = [location.pathname];
  //   if (location.hash) {
  //     titleParts.push(location.hash);
  //   }
  //   document.title = titleParts.join("");
  // }, [location]);

  return (
    <>
      <Navbar />
      {useContainer ? (
        <Container>
          <Outlet />
        </Container>
      ) : (
        <Outlet />
      )}
    </>
  );
}
